var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"scroll",attrs:{"min":"0","max":"10000","step":"5000","type":"range"}})
}
var staticRenderFns = []

export { render, staticRenderFns }